<template>
  <div>
    <div>
      <h1 class="eligible-title">{{eligibleText.heading}}</h1>
      <p class="eligible-sub">{{eligibleText.sub}}</p>
    </div>
    <div>
      <div>
        <ul class="eligible-list">
          <li v-for="point in eligibleBulletPoints" :key="point.text">{{ point.text }}</li>
        </ul>
        <div class="notes-wrap">
          <p class="eligible-sub">{{eligibleNote}}</p>
          <ul class="eligible-list">
            <li v-for="point in eligibleNoteBulletPoints" :key="point.text">{{ point.text }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      eligibleText: {
        heading: "Am I eligible?",
        sub: "Services can come from all areas of the business world. You should be:",
      },
      eligibleBulletPoints: [
        {
          text: "Based in international markets, preferably"
        },
        {
          text: "Keen to inspire and motivate Scotland’s ambitious business leaders"
        },
        {
          text: "Established and experienced within key markets/sectors for Scotland"
        },
        {
          text: "Open to sharing your knowledge, expertise and insights"
        },
        {
          text: "Willing to share your networks, to support Scotland’s economic growth"
        }
      ],
      eligibleNote: "We’re open-minded about those that we see, but have a particular interest in: ",
      eligibleNoteBulletPoints: [
        {
          text: "Fintech/ Pharma/ biotech"
        },
        {
          text: "Medtech, healthtech, healthcare"
        },
        {
          text: "Advanced manufacturing (AI, Big Data)"
        },
        {
          text: "Automotive"
        },
        {
          text: "Edtech and AI  "
        },
        {
          text: "Energy transition"
        },
        {
          text: "Renewable technologies – hydrogen, heat, offshore wind"
        },
        {
          text: "Food & drink"
        },
        {
          text: "Lifestyle products "
        },
      ]
    };
  }
};
</script>
<style lang="scss">
.eligible-sub {
  font-size: 19px;
}
.notes-wrap {
  .eligible-sub, li {
    font-weight: 500 !important;
  }
}
</style>
